import React, { useEffect, useState } from "react";
import InputField from "../StyledComp/InputField";
import { Button, Label, SecondaryButton } from "../StyledComp/StyledComp";
import { useAppSelector } from "../../store/hooks";
import MemberServices from "../../services/MemberServices";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IMember from "../../store/memberInterfaceStruct";
import AlertWithModal from "../utilityComponents/AlertWithModal";

// import { Container } from './styles';

const SendEmail: React.FC = () => {
  const memberList = useAppSelector(
    (state) => state.findMemberListUpdatedApiSlice.members
  );

  let [selectedEmailIds, setSelectedEmailIds] = useState<string[]>([]);
  let tempSelectedEmailIds: string[] = [];

  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSubject(event.target.value);
  };
  const updateTextAreaInput = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setContent(event.target.value);
  };

  useEffect(() => {
    console.log("MemberList:", memberList);
    const selectedMemberList = memberList.filter((member) => {
      return member.isChecked != null && member.isChecked == true
        ? member
        : null;
    });
    console.log("selectedMemberList", selectedMemberList);
    selectedMemberList.map((member) => {
      if (member.PrimaryAddress?.Email != null) {
        console.log("tempSelectedEmailIds:", tempSelectedEmailIds);
        if (
          !tempSelectedEmailIds.some((value) => {
            return member.PrimaryAddress?.Email == value;
          })
        ) {
          tempSelectedEmailIds.push(member.PrimaryAddress?.Email);
          console.log(member.PrimaryAddress?.Email);
        } else {
          console.log("duplicate:", member.PrimaryAddress?.Email);
        }
      }
      if (member.PublishedAddress?.Email != null) {
        console.log("tempSelectedEmailIds:", tempSelectedEmailIds);
        if (
          !tempSelectedEmailIds.some((value) => {
            return member.PublishedAddress?.Email == value;
          })
        ) {
          tempSelectedEmailIds.push(member.PublishedAddress?.Email);
        } else {
          console.log("duplicate:", member.PrimaryAddress?.Email);
        }

        tempSelectedEmailIds.push();
      }
      console.log("tempSelectedEmailIds:", tempSelectedEmailIds);
      console.log("Array size:", tempSelectedEmailIds.length);
      setSelectedEmailIds(tempSelectedEmailIds);
      console.log("SelectedEmailIds Count:", selectedEmailIds.length);
    });
  }, []);

  const onSubmit = async (event: React.MouseEvent<HTMLElement>) => {
    // console.log(memberList.members);
    let membersData = memberList;
    let memberIds: any[] = [];
    membersData.map((member) => {
      // return memberIds.push(member!!.Id);
      console.log(member.Id);
      if (typeof member.Id != "undefined") {
        console.log("defined");
        memberIds.push(member.Id);
      }
    });
    console.log(memberIds);
    let body = {
      MemberIds: memberIds,
      Emails: selectedEmailIds,
      Content: content,
      Subject: subject,
    };
    const response = await MemberServices.sendEmailToFirmMembers(body);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
      console.log("response1...", response.data.data);
      alert("Mail Sent Successfully");
      navigate("/member", { replace: false });
      dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
    } else {
      console.log("error", response);
    }
  };
  const cardStyles = {
    color: "#25284e",
    fontSize: 20,
  };
  const button = {
    color: "#fff",
    fontSize: 14,
    background: "#306288",
  };

  const removeEmailId = (index: number) => {
    console.log("Selected Email id:", selectedEmailIds[index]);
    let newSelectedEmailId = [...selectedEmailIds];
    newSelectedEmailId.splice(index, 1);
    setSelectedEmailIds(newSelectedEmailId);
  };
  return (
    <>
      <div className="dashboard-content-wrapper">
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Compose Email</h1>
        </div>
        <div>
          <div>To</div>
          <div className="send-email-to horizontal-wrapper-leftaligned">
            {/* {selectedEmailIds} */}

            {selectedEmailIds.map((selectedEmailId, index) => (
              <div className="tag-style">
                <span>{selectedEmailId}</span>
                <span
                  className="tag-closeicon"
                  onClick={() => removeEmailId(index)}
                >
                  &times;
                </span>
              </div>
            ))}
          </div>
          <div className="send-email-subject">
            <TextField
              className="textarea"
              rows={1}
              placeholder="Subject"
              id="Subject"
              name="Subject"
              onChange={updateInput}
            />
          </div>

          <div className="send-email-body">
            <TextField
              className="textarea"
              name="EmailBody"
              placeholder="Message"
              multiline
              rows={12}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void =>
                updateTextAreaInput(event)
              }
            />
          </div>
          <div className="button-wrapper">
            <div className="submit-button-div">
              <Button type="submit" onClick={onSubmit}>
                Send
              </Button>
            </div>
          </div>
        </div>
      </div>

      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default SendEmail;
